import {useContext} from "react";
import LangContext from "../contexts/LangContext";

function useGetLang()   {
    const {lang} = useContext(LangContext);
    return lang;
}
export default useGetLang;